import React, { useEffect, useState } from 'react'
import  Select  from 'react-select';
import { ciudades } from './dataCities';
//import { useMediaQuery } from 'react-responsive';


const initOptions = [ { value: "chocolate", label: "Chocolate" },
{ value: "strawberry", label: "Strawberry" },
{ value: "vanilla", label: "Vanilla" },
];
const initValue = { value: "elegir", label: "elegir" };

const SelectCity = ({estado, handleChangeCiudad, errorCity, setErrorCity}) => {
    const[dataOptions,setDataOptions]=useState(initOptions);
    const[valueSelect,setValueSelect]=useState(initValue);
    
    
    useEffect(() => {
        //console.log('indice seleccionado:...',estado)
        setValueSelect(initValue);
        handleChangeCiudad('elegir');
        formatDataOptions()
    }, [estado])
    const formatDataOptions = () => {
        const data = ciudades[estado]?.map((item,index) => {
            return { value: item, label: item }
        })
        if(data){
            setDataOptions(data)
            setErrorCity(false);
        }else{
            setDataOptions(data)
            setErrorCity(true);
        }
        
    }
    const handleChange = ({value,label}) => {
        //console.log(estado)
        setValueSelect({value,label});
        handleChangeCiudad(value);
    }
  return (
    <div><Select
    value={valueSelect}
    className="w-100 me-auto ms-auto my-2"
    options={dataOptions}
    placeholder="Buscar..."
    onChange={handleChange}
    />
    
    </div>
  )
}

export default SelectCity